module.exports = __webpack_public_path__ + "img/active_product2.78f895f.webp";